import { useState } from 'react'
import { Box, Text, Badge, Group, ActionIcon, Tooltip } from '@mantine/core'
import { IconMinus, IconPlus, IconMaximize, IconMinimize, IconRefresh, IconX } from '@tabler/icons-react'

interface CardHeaderProps {
  title: string
  badge?: { value: string | number; color?: string }
  collapsible?: boolean
  collapsed?: boolean
  onToggleCollapse?: () => void
  refreshable?: boolean
  refreshing?: boolean
  onRefresh?: () => void
  fullscreenable?: boolean
  fullscreen?: boolean
  onToggleFullscreen?: () => void
  closable?: boolean
  onClose?: () => void
  extra?: React.ReactNode
  children?: React.ReactNode
}

export function CardHeader({
  title,
  badge,
  collapsible,
  collapsed,
  onToggleCollapse,
  refreshable,
  refreshing,
  onRefresh,
  fullscreenable,
  fullscreen,
  onToggleFullscreen,
  closable,
  onClose,
  extra,
  children,
}: CardHeaderProps) {
  return (
    <Box
      style={{
        backgroundColor: 'var(--ai-body-bg)',
        borderBottom: '1px solid var(--ai-border-light)',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '4px 4px 0 0',
      }}
    >
      <Group gap="xs">
        <Text fw={600} size="sm" c="var(--ai-card-title)">{title}</Text>
        {badge && (
          <Badge size="xs" variant="light" color={badge.color ?? 'blue'}>
            {badge.value}
          </Badge>
        )}
        {children}
      </Group>

      <Group gap={4}>
        {extra}
        {refreshable && (
          <Tooltip label="Atualizar" position="top">
            <ActionIcon
              size="xs"
              variant="subtle"
              color="gray"
              onClick={onRefresh}
              style={{
                animation: refreshing ? 'spin 1s linear infinite' : undefined,
              }}
            >
              <IconRefresh size={13} />
            </ActionIcon>
          </Tooltip>
        )}
        {collapsible && (
          <Tooltip label={collapsed ? 'Expandir' : 'Recolher'} position="top">
            <ActionIcon size="xs" variant="subtle" color="gray" onClick={onToggleCollapse}>
              {collapsed ? <IconPlus size={13} /> : <IconMinus size={13} />}
            </ActionIcon>
          </Tooltip>
        )}
        {fullscreenable && (
          <Tooltip label={fullscreen ? 'Sair' : 'Tela cheia'} position="top">
            <ActionIcon size="xs" variant="subtle" color="gray" onClick={onToggleFullscreen}>
              {fullscreen ? <IconMinimize size={13} /> : <IconMaximize size={13} />}
            </ActionIcon>
          </Tooltip>
        )}
        {closable && (
          <Tooltip label="Fechar" position="top">
            <ActionIcon size="xs" variant="subtle" color="red" onClick={onClose}>
              <IconX size={13} />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </Box>
  )
}
